<script setup lang="ts">
import {LaboratoryCart} from "@/laboratory/interfaces";
import {Laboratory} from "@/core/interfaces/laboratory/Laboratory";
import Icon from "@/core/components/icon/Icon.vue";
import {computed} from "vue";

const props = defineProps<{
    cart?: LaboratoryCart;
    laboratory: Laboratory
}>();

defineEmits<{
    (e: 'displayCart'): void;
}>();

const cartQuantity = computed(() => props.cart?.lines.reduce((agg, line) => agg + line.quantity, 0));

</script>

<template>
  <v-badge
    v-if="cartQuantity && cartQuantity > 0"
    :content="cartQuantity"
    color="error"
    class="cursor-pointer hover:opacity-50"
    @click="$emit('displayCart')"
  >
    <Icon name="mdi-cart" :size="28" :color="laboratory?.branding?.primary_color" />
  </v-badge>
  <Icon
    v-else
    name="mdi-cart"
    :size="28"
    class="cursor-pointer hover:opacity-50"
    :color="laboratory?.branding?.primary_color"
    @click="$emit('displayCart')"
  />
</template>

<style scoped>

</style>
